// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"90":"5c84567c","453":"b72e2015"}[chunkId] + ".chunk.js";
};